import { useSelector } from "react-redux";
import { useProductContext } from "vino/context";
import { selectCartLineItemById } from "store/vino/cartSlice";
import AddToCartButton from "../AddToCartButton";
import QuantityInput from "../QuantityInput";

const AddToCart = () => {
	const {
		product: { variant },
	} = useProductContext();

	const cartLineItem = useSelector((state) =>
		selectCartLineItemById(state, variant.id)
	);

	if (variant.available <= 0) {
		return (
			<button className="btn btn-primary action-btn">
				<div className="add-prod flex w-full justify-center">
					<span className="mr-3">Out of stock</span>
				</div>
			</button>
		);
	}

	return (
		<div className="flex justify-between">
			{cartLineItem && cartLineItem.quantity > 0 ? (
				<QuantityInput cartLineItem={cartLineItem} />
			) : (
				<AddToCartButton />
			)}
		</div>
	);
};

export default AddToCart;
